import { startsWith } from "lodash";

export const maskPhoneNumber = (number?: string) => {
  const maskSymbol = "•";
  if (number) {
    if (startsWith("0", number)) {
      return `${number.substring(0, 3)} ${number
        .substring(3, 6)
        .replace(/./g, maskSymbol)} ${number.substring(6, 8)}`;
      // .replace(/./g, maskSymbol)}${number.substring(8)}`;
    }
    // 66123456789 -> 661 2345 6789
    if (startsWith("66", number)) {
      return `${number.substring(0, 3)} ${number
        .substring(3, 7)
        .replace(/./g, maskSymbol)} ${number.substring(7, 9)}`;
      // .replace(/./g, maskSymbol)}${number.substring(9)}`;
    }
    // +66123456789 -> +661 2345 6789
    if (startsWith("+66", number)) {
      return `${number.substring(0, 4)} ${number
        .substring(4, 8)
        .replace(/./g, maskSymbol)} ${number.substring(8, 10)}`;
      // .replace(/./g, maskSymbol)}${number.substring(10)}`;
    }
    // default case
    return `${number.substring(0, 4)} ${number
      .substring(4, 8)
      .replace(/./g, maskSymbol)} ${number.substring(8, 10)}`;
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
  }
  return ``;
};

export const maskEmail = (email?: string) => {
  const maskSymbol = "•";
  if (email) {
    return `${email.substring(0, 3)} ${maskSymbol.repeat(
      email.substring(3).length
    )}`;
  }
  return ``;
};

export const maskProfilePhoneNumber = (number?: string) => {
  const maskSymbol = "*";
  const trimMobileNo = number?.replace(/\D/g, "");
  if (trimMobileNo) {
    if (startsWith("0", trimMobileNo)) {
      return `${trimMobileNo.substring(0, 2)}${trimMobileNo
        .substring(2, 5)
        .replace(/./g, maskSymbol)}${trimMobileNo.substring(5, 8)}`;
      // .replace(/./g, maskSymbol)}${trimMobileNo.substring(8)}`;
    }
    // 66123456789 -> 66123456789
    if (startsWith("66", trimMobileNo)) {
      return `${trimMobileNo.substring(0, 2)}${trimMobileNo
        .substring(2, 6)
        .replace(/./g, maskSymbol)}${trimMobileNo.substring(6, 9)}`;
      // .replace(/./g, maskSymbol)}${trimMobileNo.substring(9)}`;
    }
    // +66123456789 -> +66123456789
    if (startsWith("+66", trimMobileNo)) {
      return `${trimMobileNo.substring(0, 4)}${trimMobileNo
        .substring(4, 7)
        .replace(/./g, maskSymbol)}${trimMobileNo.substring(7, 10)}`;
      // .replace(/./g, maskSymbol)}${trimMobileNo.substring(10)}`;
    }
    // default case
    return `${trimMobileNo.substring(0, 3)}${trimMobileNo
      .substring(3, 7)
      .replace(/./g, maskSymbol)}${trimMobileNo.substring(7, 10)}`;
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
  }
  return ``;
};

export const maskBankAccountNumber = (
  accountNumber: string,
  maskSymbol?: string
) => {
  const defaultMaskedString = "************";
  const prefixMaskedSymbol = maskSymbol
    ? defaultMaskedString.replace(/./g, "*")
    : defaultMaskedString;
  const suffixAccountNumber = accountNumber.slice(
    accountNumber.length - 4,
    accountNumber.length
  );
  return `${prefixMaskedSymbol}${suffixAccountNumber}`;
};

export const maskCitizenId = (citizenId: string, maskSymbol?: string) => {
  const defaultMaskedString = "*********";
  const prefixMaskedSymbol = maskSymbol
    ? defaultMaskedString.replace(/./g, "*")
    : defaultMaskedString;
  const suffixCitizenId = citizenId.slice(
    citizenId.length - 4,
    citizenId.length
  );
  return `${prefixMaskedSymbol}${suffixCitizenId}`;
};

export const maskPassportNo = (passportNo: string, maskSymbol?: string) => {
  const defaultMaskedString = "*****";
  const prefixMaskedSymbol = maskSymbol
    ? defaultMaskedString.replace(/./g, "*")
    : defaultMaskedString;
  let suffixCitizenId = "";
  if (passportNo.length <= 4) {
    suffixCitizenId = passportNo.slice(
      passportNo.length - 1,
      passportNo.length
    );
  } else {
    suffixCitizenId = passportNo.slice(
      passportNo.length - 4,
      passportNo.length
    );
  }
  return `${prefixMaskedSymbol}${suffixCitizenId}`;
};
